import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=36488cdb&scoped=true&"
import script from "./Issues.vue?vue&type=script&lang=ts&"
export * from "./Issues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36488cdb",
  null
  
)

export default component.exports